Ext.define('SA.lq.view.ConditionList', {
    constructor({listCmp, cmpFactory, modelFactory}) {
        this.listCmp = listCmp;
        this.cmpFactory = cmpFactory;
        this.modelFactory = modelFactory;
    },

    addDefaultConditionForAttributeId(attributeId) {
        this.listCmp.add(this.createCmp({
            listOperator: this.getListOperatorValue(),
            condition: this.modelFactory.createUnaryCondition({attributeId, operator: '>', operand: 0})
        }));

        this.changeHandler();
    },

    createCmp(params) {
        return this.cmpFactory.createCmp(params);
    },

    createCmps({model}) {
        var listOperator = model.getOperator();

        return model.getConditions().map(condition => this.createCmp({listOperator, condition}));
    },

    getCmps() {
        return this.listCmp.getChildItems();
    },

    getListOperatorValue() {
        return this.getCmps()[0]?.getListOperatorValue() ?? 'and';
    },

    mapToModel() {
        var conditions = this.getCmps().map(cmp => {
            if (cmp.hasBetweenOperator()) {
                return this.modelFactory.createBetweenCondition({
                    attributeId: cmp.getAttributeId(),
                    gteOperand: cmp.getGteValue(),
                    lteOperand: cmp.getLteValue()
                });
            }

            return this.modelFactory.createUnaryCondition({
                attributeId: cmp.getAttributeId(),
                operator: cmp.getConditionOperatorValue(),
                operand: cmp.getUnaryOperandValue()
            });
        });

        return this.modelFactory.createList({operator: this.getListOperatorValue(), conditions});
    },

    removeItem(item) {
        this.listCmp.remove(item);
        this.changeHandler();
    },

    setChangeHandler(changeHandler) {
        this.changeHandler = changeHandler;
    },

    setListOperatorValue(value) {
        this.getCmps().forEach(cmp => cmp.setListOperatorValue(value));
        this.changeHandler();
    },

    setState(model) {
        var existingCmps = this.getCmps(),
            freshCmps = this.createCmps({model}),
            sameCount = existingCmps.length === freshCmps.length,
            sameState = existingCmps
                .map((existingCmp, index) => [existingCmp, freshCmps[index]])
                .every(([existingCmp, freshCmp]) => existingCmp.sameState(freshCmp));

        if (sameCount && sameState) {
            return;
        }

        this.listCmp.setItems(freshCmps);
        this.changeHandler();
    }
});